import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { createAppContext } from 'mini-app-context';
import { getItem, setItem } from 'mini-localstorage';
import { SessionData } from 'owa-service/lib/types/SessionData';

const USER_FAST_BOOT_SETTINGS_KEY = 'UserFastBootSettings';

let changesDetected = null;

/**
 * Method to save user fast boot settings after arrival of session data
 * @param options
 */
export function saveUserFastBootSettingsUsingSessionData(sessionDataPromise: Promise<SessionData>) {
    sessionDataPromise.then(sessionData => {
        const {
            TimeZone,
            DateFormat,
            TimeFormat,
            MailboxTimeZoneOffset,
        } = sessionData?.owaUserConfig?.UserOptions;
        const { language } = sessionData;
        setItem(USER_FAST_BOOT_SETTINGS_KEY, {
            TimeZone,
            DateFormat,
            TimeFormat,
            MailboxTimeZoneOffset,
            language,
        });
        return sessionData;
    });
}

/**
 * Method to retrieve user fast boot settings from local storage
 */
export function getUserFastBootSettings() {
    let fastBootSettings: any = null;
    try {
        fastBootSettings = getItem(USER_FAST_BOOT_SETTINGS_KEY);
    } catch (error) {
        // Silently fail
    }

    return fastBootSettings;
}

export function identifyUserFastBootSettingsChanges(culture: string, fastBootSettings: any) {
    const userConfig = getUserConfiguration();
    const changes = [];
    try {
        const { TimeZone, DateFormat, TimeFormat, MailboxTimeZoneOffset } = userConfig?.UserOptions;
        const language = culture;

        // If settings are present then need to check if values are same or not
        if (fastBootSettings) {
            // Comparing 5 known properties for which we need the info
            if (fastBootSettings.TimeZone !== TimeZone) {
                changes.push('tz');
            }
            if (fastBootSettings.DateFormat !== DateFormat) {
                changes.push('df');
            }
            if (fastBootSettings.TimeFormat !== TimeFormat) {
                changes.push('tf');
            }
            if (
                JSON.stringify(fastBootSettings.MailboxTimeZoneOffset) !==
                JSON.stringify(MailboxTimeZoneOffset)
            ) {
                changes.push('mbtzof');
            }
            if (fastBootSettings.language !== language) {
                changes.push('lang');
            }
        }

        // Set it for logging later as logger is presently not active at this point so logging will happen
        // once we bootstrap the application
        changesDetected = changes;
    } catch (error) {
        changesDetected = 'Error in JSON stringify';
        // Just to avoid any error here to prevent breaking any thing
    }
    return changes;
}

// Exported to log the changes detected
export function logUserFastBootSettingsChanges() {
    if (changesDetected?.length) {
        try {
            createAppContext().signal(
                'UserFastBootSettingsChanges',
                { changes: JSON.stringify(changesDetected) },
                { isCore: true }
            );
        } catch (error) {
            // Handling JSON stringify error as good practice
        }
    }
}
